module.exports = __webpack_public_path__ + "static/media/bicycle.883c123b.svg";